/* eslint-disable no-console */
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) {
      console.log('App served from cache by a service worker.', registration)
    },
    registered (registration) {
      console.log('Service worker has been registered.', registration)
    },
    cached (registration) {
      console.log('Content has been cached for offline use.', registration)
    },
    updatefound (registration) {
      console.log('New content is downloading.', registration)
    },
    updated (registration) {
      console.log('New content is available; dispatching swUpdated event.', registration)
      // -> Despierta el modal
      window.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }))
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  // Cuando el SW activo cambie (después de SKIP_WAITING) recarga la página
  navigator.serviceWorker?.addEventListener('controllerchange', () => {
    window.location.reload()
  })
}
